/**
 * Persists which tab set a device should show ("full" = Approvals visible,
 * "floor" = Approvals hidden) so the bottom tab bar can resolve Approvals
 * visibility PRE-PAINT from a cookie instead of a server prop. This is what
 * stops the Approvals tab flickering 4→5 on navigation: loading skeletons and
 * real pages emit identical markup, and this attribute (read by the layout
 * boot script, written by SupplyTierCookieSync) hides Approvals for floor
 * staff before first paint. Mirrors lib/cluckup/tier's CLUCKUP_TIER_COOKIE.
 *
 * Value is non-sensitive; /supply/approvals stays server-gated
 * (requireSupplyApprover) regardless of this hint.
 */
export const SUPPLY_TIER_COOKIE = "fb_supply_tier";
export const SUPPLY_TIER_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
export type SupplyTierCookieValue = "full" | "floor";
